export const getDropdownFilterLastUpdate = () => {
    return {
        i18n: "installationoverview.last_update",
        label: "Last Update",
        id: "last_timestamp",
        options: [
            {
                type: "radio",
                variable: "time",
                selected: "",
                options: [
                    {
                        id: "last_timestamp-minute",
                        i18n: "installationoverview.timestamps.last_timestamp-minute",
                        label: "Less than a <strong>minute</strong> ago",
                        value: false
                    },
                    {
                        id: "last_timestamp-hour",
                        i18n: "installationoverview.timestamps.last_timestamp-hour",
                        label: "Less than a <strong>hour</strong> ago",
                        value: false
                    },
                    {
                        id: "last_timestamp-day",
                        i18n: "installationoverview.timestamps.last_timestamp-day",
                        label: "Less than a <strong>day</strong> ago",
                        value: false
                    },
                    {
                        id: "last_timestamp-week",
                        i18n: "installationoverview.timestamps.last_timestamp-week",
                        label: "Less than a <strong>week</strong> ago",
                        value: false
                    },
                    {
                        id: "last_timestamp-month",
                        i18n: "installationoverview.timestamps.last_timestamp-month",
                        label: "Less than a <strong>month</strong> ago",
                        value: false
                    },
                    {
                        id: "last_timestamp-year",
                        i18n: "installationoverview.timestamps.last_timestamp-year",
                        i18nFallback: "Less than a <strong>year</strong> ago",
                        label: "Less than a <strong>year</strong> ago",
                        value: false
                    },
                    {
                        id: "last_timestamp-year-plus",
                        i18n: "installationoverview.timestamps.last_timestamp-year-plus",
                        i18nFallback: "More than a <strong>year</strong> ago",
                        label: "More than a <strong>year</strong> ago",
                        value: false
                    }
                ]
            }
        ]
    };
};